// Domain Type
const DOMAIN_TYPE = process.env.REACT_APP_DOMAIN_TYPE;

// URLs
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const DEPLOYED_URL = process.env.REACT_APP_DEPLOYED_URL;
const INVITE_REGISTER_URL = `${DEPLOYED_URL}/invite-register`;

module.exports = {
  getBaseUrl: function () {
    return BASE_URL;
  },
  getAPI: function () {
    return `${BASE_URL}/api/`;
  },
  getDomainType: function () {
    return DOMAIN_TYPE;
  },
  getSocketAPI: function () {
    return BASE_URL;
  },
  getDeployedUrl: function () {
    return DEPLOYED_URL;
  },
  getInviteRegisterUrl: function () {
    return INVITE_REGISTER_URL;
  },
  getDefaultCurrrency: function () {
    return 'KWD';
  },
  getLanguageList: function () {
    var languages = [
      {
        id: 'en',
        name: 'English',
      },
      {
        id: 'ar',
        name: 'Arabic',
      },
    ];
    return languages;
  },
  getExeVersions: function () {
    const versions = [
      { value: '1.1.8', label: '1.1.8 or higher' },
      { value: '1.1.7', label: '1.1.7 or lower' },
    ];
    return versions;
  },
  getSoftwareAppLinks: function () {
    const windowsEXEs =
      DOMAIN_TYPE === 'test'
        ? 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/2420feae-a698-4de9-9679-332bfbe1ba68/System%20Tracker%20Setup%201.1.9%20WINDOWS%20test.exe'
        : BASE_URL?.includes('dev')
          ? 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/PREPRODUCTION/a2ee38f6-507a-41ae-bbb4-72d2e17b29ed/System%20Tracker%20Setup%201.1.9%20WINDOWS%20production.exe'
          : 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/a2ee38f6-507a-41ae-bbb4-72d2e17b29ed/System%20Tracker%20Setup%201.1.9%20WINDOWS%20production.exe';

    const macDMGs =
      DOMAIN_TYPE === 'test'
        ? 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/2420feae-a698-4de9-9679-332bfbe1ba68/System%20Tracker%20Setup%201.1.8%20WINDOWS%20test.exe'
        : BASE_URL?.includes('dev')
          ? 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/PREPRODUCTION/a2ee38f6-507a-41ae-bbb4-72d2e17b29ed/System%20Tracker%20Setup%201.1.8%20WINDOWS%20production.exe'
          : 'https://infowarewebtrackerprod.s3.ap-south-1.amazonaws.com/a2ee38f6-507a-41ae-bbb4-72d2e17b29ed/System%20Tracker%20Setup%201.1.8%20WINDOWS%20production.exe';

    return { windowsEXEs, macDMGs };
  },
};
